import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import {
  LIST_ALL_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY,
  LIST_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY
} from '@/constants/scheduleExpectations';
import AppContext from '@/contexts/appContext';
import ScheduleExpectationCycleRepository from '@/repositories/ScheduleExpectationCycleRepository';
import { PatchScheduleExpectationCycleData } from '@/types/scheduleExpectation';
import mapAxiosErrorMessages from '@/utils/mapAxiosErrorMessages';

export const usePatchScheduleExpectationCycle = (phaseId: string) => {
  const { addMessage } = useContext(AppContext);
  const queryClient = useQueryClient();
  const repository = ScheduleExpectationCycleRepository();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: PatchScheduleExpectationCycleData }) =>
      repository.patch({ id, data }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [LIST_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY, phaseId]
        }),
        queryClient.invalidateQueries({
          queryKey: [LIST_ALL_SCHEDULE_EXPECTATION_CYCLES_QUERY_KEY, phaseId]
        })
      ]);
    },
    onError: (error) => {
      addMessage(mapAxiosErrorMessages(error as AxiosError));
    }
  });
};
